{
  "adminNav": {
    "liveStreams": "Live streams",
    "users": "Users",
    "blockedRegistrations": "Blocked registrations",
    "abuseIncidents": "Trial reuse reports"
  },
  "faqs": {
    "breadcrumb": "FAQs",
    "items": {
      "activeStreamHealthMonitoring": {
        "answer": "It's a dedicated system in place that continuously monitors your live stream. If we detect any problem with your live stream it will be automatically resolved without you having to keep an eye on it. Once you start your live stream, you can rest assured that it will always stay up and running!",
        "question": "What is active stream health monitoring?"
      },
      "canIScheduleLiveStream": {
        "answer": "Yes! You get many scheduling options! You can choose if the live stream should loop indefinitely, choose when the live stream starts and when it ends (or to keep on looping indefinitely 24/7)",
        "question": "Can I schedule my live stream?"
      },
      "canRunMultipleLiveStreams": {
        "answer": "Yes! Add more stream slots to your subscription anytime. Volume pricing kicks in automatically — see the pricing page for details.",
        "question": "Can I run multiple live streams?"
      },
      "howCancelSubscription": {
        "answer": "You can cancel your subscription at any time by going to your billing settings.",
        "question": "How can I cancel my subscription?"
      },
      "keepComputerRunning": {
        "answer": "No, you can close your computer and your live stream will continue to run.",
        "question": "Do I have to keep my computer running for my live stream?"
      },
      "moreQuestionsContact": {
        "answer": "You can contact us through the Support Chat at any time! Or via email at info@streaminal.com",
        "question": "I have more questions, how can I contact you?"
      },
      "streamToMultiplePlatforms": {
        "answer": "Yes! You can stream the same content to up to 3 platforms with the same subscription!",
        "question": "Can I stream to multiple platforms?"
      },
      "updateContentWithoutInterrupting": {
        "answer": "Yes! You can update your content at any time without interrupting your live stream!",
        "question": "Can I update my content after I start my live stream without interrupting it?"
      },
      "whatIsMultistreaming": {
        "answer": "Multistreaming is the ability to stream the same content to multiple platforms simultaneously. For example, you can stream to YouTube and Twitch at the same time with only 1 subscription!",
        "question": "What is multistreaming?"
      },
      "whatIsStreamKey": {
        "answer": "A stream key is the bridge between a streaming software and your live stream. It's the way your streaming software knows where to send your live stream.",
        "question": "What is a stream key?"
      },
      "whatIsSubscription": {
        "answer": "A subscription enables you to run a live stream whenever you want! You can run 1 live stream per subscription, can stop/cancel the live stream and start streaming something else using the same subscription!",
        "question": "What is a subscription?"
      },
      "willVideosLoopIndefinitely": {
        "answer": "Yes! Your video will loop indefinitely until you stop your live stream or you schedule it to end at a specific time.",
        "question": "Will my videos loop indefinitely?"
      }
    },
    "pageTitle": "Frequently asked questions",
    "sections": {
      "service": "Service",
      "serviceSubtitle": "Everything about streaming services and features",
      "subscription": "Subscription",
      "subscriptionSubtitle": "Plans, pricing, and billing information"
    },
    "subheading": "Everything you need to know about Streaminal. Can't find what you're looking for? Feel free to chat with our support team."
  },
  "nav": {
    "admin": "Admin",
    "collapseSidebar": "Collapse sidebar",
    "expandSidebar": "Expand sidebar",
    "faqs": "FAQs",
    "liveStreams": "Live streams",
    "logout": "Log out",
    "openMenu": "Open menu"
  },
  "notFound": {
    "description": "The page you're looking for doesn't exist or has been moved.",
    "goHome": "Go to dashboard",
    "title": "Page not found"
  },
  "userMenu": {
    "logout": "Log out",
    "open": "Account menu"
  }
}
